<template>
  <section class="container">
    <img
      v-if="isPreview "
      ref="image"
      class="landscape-mini-colorCode"
      :src="`data:image/png;base64,${imageData}`"
    />
    <img
      v-else-if="buildNumber "
      ref="image"
      class="landscape-mini-colorCode"
      :src="`${staticUrl}Images/${colorCodeImagePath}` + '?' + buildNumber"
    />
  </section>
</template>

<script>
import { getStaticUrl } from '@/helpers';
import axios from 'axios';
import AssetsApiService from '@/services/assetsServices/assetsApiService';

export default {
  props: ['section', 'colorCodeImagePath', 'radio', 'isPreview'],
  data() {
    return {
      buildNumber: 0,
      imageData: ''
    };
  },
  async mounted() {
    if (this.isPreview) {
      this.imageData = await AssetsApiService.getAssetFile(this.colorCodeImagePath);
    } else {
      axios
        .get(`${this.staticUrl}assetsConfig.json?` + Date.now())
        .then((result) => {
          this.buildNumber = result.data.buildNumber;
        });
    }
  },
  computed: {
    staticUrl() {
      return getStaticUrl(this.radio, this.$route.name);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  display: inline-block;
  z-index: 3;
}

/* LandscapeMinI */

.landscape-mini-colorCode {
  max-height: 90%;
  max-width: 100%;
  padding: 10px;
}
</style>
